<template>
  <div>
    <Head title="Create Domain" />
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag='Link' href="/sector-targets">Sector Targets</b-breadcrumb-item>
      <b-breadcrumb-item tag='Link' active>
        Create Domain
      </b-breadcrumb-item>
    </b-breadcrumb>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full" label="Name" />
        </div>

        <div v-if="sectorTarget" class="p-6 m-6 bg-indigo-100 rounded">
          The sector target '{{ sectorTarget.label }}' will automatically be attached to this vertical.
        </div>

        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Vertical</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    LoadingButton,
    TextInput,
  },
  props: {
    market: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        market_id: this.market ? this.market.id : null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/verticals')
    },
  },
}
</script>
